



















import { Component, Watch, Vue } from 'vue-property-decorator'
import DefaultTable from '@/views/formList/defaultTable.vue'
import CustomTable from '@/components/custom-table/index.vue'
import AbpBase from '@/lib/abpbase'
import CustomTableApi from '@/api/customTable/api'
import RechargeCardApi from '@/api/marketing/rechargeCard/index'
@Component({
  components: {
    DefaultTable,
    CustomTable,
  },
})
export default class RechargeCardProductList extends AbpBase {
  rechargeApi: string = CustomTableApi.rechargeProductApi
  rechargeFilters: any[] = [
    {
      label: '卡密名称',
      type: 'input',
      props: {
        placeholder: '请输入',
      },
      key: 'Filter',
    },
  ]
  rechargeColumns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '订单号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '卡号',
      key: 'code',
      align: 'center',
    },
    {
      title: '密码',
      key: 'passWord',
      align: 'center',
    },
    {
      title: '是否使用',
      slot: 'isUse',
      align: 'center',
    },
    {
      title: '会员ID',
      key: 'vipId',
      align: 'center',
    },
    {
      title: '手机号',
      key: 'phone',
      align: 'center',
    },
    {
      title: '会员名称',
      key: 'vipName',
      align: 'center',
    },
    {
      title: '使用日期',
      slot: 'useTime',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'recharegeaction',
      align: 'center',
    },
  ]
  handleSelectCustomTable(e) {
    console.log(e)
  }
  editRechargeCard(item) {
    console.log(item, this.$refs['rechargeRef']);
    (this.$refs['rechargeRef'] as any).RechargeableCardId = item.id;
    (this.$refs['rechargeRef'] as any).handleClickSelect();
  }
  // 删除单个
  deleteRecharge(item) {
    console.log(item);
     RechargeCardApi.batchDeleteProdcut([item.id]).then(res => {
      this.$Notice.success({
        title: '删除成功'
      });
      ;(this.$refs['rechargeRef'] as any).submitFn();
    })
  }
  // 批量删除
  batchDelete(ids) {
    console.log(ids);
    RechargeCardApi.batchDeleteProdcut(ids).then(res => {
      this.$Notice.success({
        title: '删除成功'
      });
      ;(this.$refs['rechargeRef'] as any).submitFn();
    })
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    RechargeCardApi.exportRechargeableProduct((this.$refs['rechargeRef'] as any).RechargeableCardId)
      .then((res) => {
        console.log(res)
        this.download(res.data)
      })
      .catch((err) => {
        console.log(err);
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '卡密商品.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
